/* istanbul ignore file */
import { CreatePageLayout } from 'framework/ui/layout';
import { CreateForm } from 'framework/form';
import useJournalEntryService from 'domain/finance/journalEntry/useJournalEntryService';
import { useJournalEntryUrl, useJournalEntryId } from 'domain/finance/journalEntry/shared/useJournalEntryRouting';
import ReverseLedgerBreadcrumbs from 'domain/finance/journalEntry/createupdate/Reverse/Breadcrumbs';
import JournalEntryForm from 'domain/finance/journalEntry/createupdate/JournalEntryForm';

const ReverseLedgerPage = () => {
  const { revokeJournalEntry, getReversedEntryData, getValidationSchema } = useJournalEntryService();
  const { getListUrl } = useJournalEntryUrl();
  const id = useJournalEntryId();

  return (
    <CreateForm
      submitFormFunc={() => revokeJournalEntry(id)}
      getDataFunc={() => getReversedEntryData(id)}
      afterSubmit={{
        redirect: getListUrl(),
        message: 'You are awesome! The Journal Entry has been successfully reversed.',
      }}
      getValidationSchemaFunc={getValidationSchema}
      initialData={{
        transfers: [{}, {}],
      }}
    >
      <CreatePageLayout breadcrumbs={<ReverseLedgerBreadcrumbs />} title="Storno: Journal Entry">
        <JournalEntryForm isDisabled />
      </CreatePageLayout>
    </CreateForm>
  );
};

export default ReverseLedgerPage;
